import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Tournament from '@/views/Tournament.vue'
import Pool from '@/views/Pool.vue'
import Invite from '@/views/Invite.vue'
import Profile from '@/views/Profile.vue'
import Password from '@/views/Password.vue'
import ViewEntry from '@/views/ViewEntry.vue'
import ResultEntry from '@/views/ResultEntry.vue'
import PoolEntry from '@/views/PoolEntry.vue'

/*const scrollBehavior = ( to, from, savedPosition ) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return {x: 0, y: 0}
  }
}*/

Vue.use(Router)

let router = new Router({
  mode: 'history',
  //scrollBehavior,
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/tournament',
      name: 'tournament',
      component: Tournament
    },
    {
      path: '/pool',
      name: 'pool',
      component: Pool
    },
    {
      path: '/invite',
      name: 'invite',
      component: Invite
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/password',
      name: 'password',
      component: Password
    },
    {
      path: '/view-entry',
      name: 'view-entry',
      component: ViewEntry,
      props: true
    },
    {
      path: '/result-entry',
      name: 'result-entry',
      component: ResultEntry
    },
    {
      path: '/pool-entry',
      name: 'pool-entry',
      component: PoolEntry
    }
  ]
})

export default router
